class PlannerCourseGroupSelectionController {

    constructor() {
        this.model = plannerApplication.data.courseGroups;
        this.view = new CourseGroupListSelectionView({model: this.model});
        this.view.render();

        this.sectionNode = $('.section-course-groups');
        this.btnNext = this.sectionNode.find('.btn-next');

        this.selectionInputs = this.sectionNode.find('.btn-check');

        this.selectionInputs.attr('checked', false);
        this.btnNext.enableNextBtnIf(false);

        this.selectCourseGroup();
        this.selectionInputs.change(this.onUpdated.bind(this));
    };

    onUpdated(e) {
        let valid = false;
        e = nullIfUndefined(e);
        if (e != null) {
            let input = $(e.target);
            let courseGroupName = input.val();
            let courseGroup = plannerApplication.data.courseGroupForName(courseGroupName);

            valid = true;
            plannerApplication.yourProfile.setCourseGroupModel(courseGroup);
            plannerApplication.controllers.plannerCourseController.updateGroupSelection(courseGroup);
            plannerApplication.userDataUpdated();
        }


        this.btnNext.enableNextBtnIf(valid);
    };

    selectCourseGroup() {
        if (plannerApplication.yourProfile.getCourseGroupName() != null) {
            let thisObj = this;
            _.each(this.selectionInputs, function (selectionInput) {
                selectionInput = $(selectionInput);
                let courseGroup = selectionInput.val();
                if (courseGroup === plannerApplication.yourProfile.getCourseGroupName()) {
                    selectionInput.attr('checked', true);
                    thisObj.btnNext.enableNextBtnIf(true);
                }
            });
        }
    }
}
